<div class="termsAndCondition" [innerHTML]="termsAndConditions">
    
</div>
